export default "__VITE_ASSET__BKrICL5g__"